import { NotificationsStatsigFeatureGate } from './feature-gate'
import { NotificationsStatsigStore } from './store'

export const NotificationsStatsig = {
  Store: NotificationsStatsigStore,
  FeatureGate: NotificationsStatsigFeatureGate,
}
